export default "__VITE_ASSET__DggvG7Gv__"